<template>
	<div class="index module-item-style service-wrap">
		<div class="index-evaluate-analyze index-services-activity table-box">
		  <el-table
		    v-loading="isLoading"
		    stripe
		    :data="tableData"
		    :header-cell-style="{ background: '#f2f2f2' }"
		    style="width: 98%;border: 1px solid #ebeef5;margin-top: 20px;"
		  >
		    <el-table-column width="50" label="客服">
		      <template slot-scope="scope">
		        <img
		          class="table-image table-image-avatar "
		          :src="avatarX(scope.row.csHeadimg)"
		          alt="客服头像"
		        />
		      </template>
		    </el-table-column>
		    <el-table-column prop="csName" label=""> </el-table-column>
		    <el-table-column prop="isOnline" align="center" label="在线状态">
		      <template slot-scope="scope">
		        <div class="onlineSta" v-if="scope.row.isOnline == 0">
		          <img :src="imgOffline" v-if="scope.row.isOnline == 0" alt="" />
		          <span class="onlineStatus offline">{{
		            scope.row.isOnlineStr
		          }}</span>
		        </div>
		        <div class="onlineSta" v-if="scope.row.isOnline == 1">
		          <img
		            :src="pcOnImg"
		            v-if="scope.row.showPcIcon == 1"
		            class="mgt5"
		            alt="PC端"
		          />
		          <img
		            :src="clientOnImg"
		            v-if="scope.row.showClientIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="mobileOnImg"
		            v-if="scope.row.showAppIcon == 1"
		            alt=""
		          />
		          <span class="onlineStatus online">{{
		            scope.row.isOnlineStr
		          }}</span>
		        </div>
		        <div class="onlineSta" v-if="scope.row.isOnline == 2">
		          <img
		            :src="pcOffImg"
		            v-if="scope.row.showPcIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="clientOffImg"
		            v-if="scope.row.showClientIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="mobileOffImg"
		            v-if="scope.row.showAppIcon == 1"
		            alt=""
		          />
		          <!--<img :src="imgHold" alt=""> -->
		          <span class="onlineStatus rest">{{ scope.row.isOnlineStr }}</span>
		        </div>
		      </template>
		    </el-table-column>
		    <el-table-column prop="todayCumulativeTime" label="今日在线时长">
		    </el-table-column>
		    <el-table-column prop="receptionNum" label="实时接待人数">
		    </el-table-column>
		    <el-table-column prop="maxNum" width="80" label="接待上限">
		    </el-table-column>
		    <el-table-column prop="callingNum" width="80" label="会话量">
		    </el-table-column>
		    <el-table-column prop="avgcalltimeData" width="100" label="平均接待时长">
		    </el-table-column>
		  </el-table>
		  <pagenations style="padding-right:15px;" :total="total" :size="pageSize" @pageHandler="pageOperate">
		  </pagenations>
		</div>
	</div>
	
</template>

<script>
	import avatar0 from "@/assets/images/client_avatar_empty.png";
	import avatar1 from "@/assets/images/client_avatar1.png";
	import avatar2 from "@/assets/images/client_avatar2.png";
	import avatar3 from "@/assets/images/client_avatar3.png";
	import avatar4 from "@/assets/images/client_avatar4.png";
	import avatar5 from "@/assets/images/client_avatar5.png";
	import avatar6 from "@/assets/images/client_avatar6.png";
	import avatar7 from "@/assets/images/client_avatar7.png";
	
	import imgHold from "@/assets/images/icon_server_holdon.png";
	import imgOffline from "@/assets/images/icon_server_offline.png";
	import imgOnline from "@/assets/images/icon_server_online.png";
	import pcOnImg from "@/assets/images/icon_pc_on.png";
	import pcOffImg from "@/assets/images/icon_pc_off.png";
	import clientOnImg from "@/assets/images/icon_client_on.png";
	import clientOffImg from "@/assets/images/icon_client_off.png";
	import mobileOnImg from "@/assets/images/icon_mobile_on.png";
	import mobileOffImg from "@/assets/images/icon_mobile_off.png";
	
	import pagenations from "@/components/pagenations/pagenations";
	
	export default {
		name:"service-today-activity",
		components:{
			pagenations,
		},
		data() {
			return {
				pageSize: 10,
				currentPage: 1,
				total: 0,
				isLoading: false,
				tableData: [],
				imgHold: imgHold,
				imgOffline: imgOffline,
				imgOnline: imgOnline,
				pcOnImg: pcOnImg,
				pcOffImg: pcOffImg,
				clientOnImg: clientOnImg,
				clientOffImg: clientOffImg,
				mobileOnImg: mobileOnImg,
				mobileOffImg: mobileOffImg
			}
		},
		created() {
			this.getServiceActiveData()
		},
		methods:{
			/**
			 *  分页操作
			 * @param val
			 */
			pageOperate(val) {
			  if (val.type == "currentChange") {
			    this.currentPage = val.val;
			  } else if (val.type == "sizeChange") {
			    this.pageSize = val.val;
			  }
			  this.getServiceActiveData();
			},
			/**
			 * 显示访客头像
			 * 截取头像名称中的数字
			 */
			avatarX(avatar) {
			  const img = avatar.substring(avatar.length - 5, avatar.length - 4);
			  switch (img) {
			    case "y":
			      return avatar0;
			      break;
			    case "1":
			      return avatar1;
			      break;
			    case "2":
			      return avatar2;
			      break;
			    case "3":
			      return avatar3;
			      break;
			    case "4":
			      return avatar4;
			      break;
			    case "5":
			      return avatar5;
			      break;
			    case "6":
			      return avatar6;
			      break;
			    case "7":
			      return avatar7;
			      break;
			    default:
			      return avatar;
			      break;
			  }
			},
			getServiceActiveData() {
			  this.$http.IndexServiceActiveAPI({
			      pageNum: this.currentPage,
			      pageSize: this.pageSize
			    }).then(res => {
			      if (res.status == 1) {
			        this.tableData = res.data.cserviceList;
			        this.total = res.data.total;
			      }
			    });
			},
		}
	}
</script>

<style>
	.service-wrap .index-services-activity{
		padding: 15px 0 15px 0;
		max-height: initial;
	}
	.service-wrap .index-services-activity .el-table__body-wrapper{
		height: auto;
	}
	.service-wrap .index-services-activity .pagenations{
		padding-top: 22px;
	}
</style>
